// extracted by mini-css-extract-plugin
export default {"container":"TripTypesLandingPage_container__hZK+L"};